import { FC } from "react";
import { OverviewArchive, SelectDropdownFilter } from "@/components";
import i18next from "i18next";
import challs_background from "@/assets/cover/challenges.webp";
import { challengeOverviewProps } from "../../types/props/OverviewProps";
import { filterButtons } from "../../utils/challengeOverviewFilters";
import { DropdownStatusOptions } from "@/utils/constants/dropDownOption";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { Button, Flex, Heading } from "@radix-ui/themes";
import { Cross1Icon } from "@radix-ui/react-icons";

export const ChallengeOverviewUi: FC<challengeOverviewProps> = ({
  selectedCreatorType,
  loading,
  setSelectedCreatorType,
  selectedGame,
  setSelectedGames,
  challengeTitle,
  setChallengeTitle,
  selectedStatus,
  setSelectedStatus,
  zone,
}) => {
  const headline = zone
    ? `${zone.title} ${i18next.t("strings.challenges")}`
    : i18next.t("strings.challenges");
  return (
    <>
      <OverviewArchive
        headline={headline}
        linkToBtnText="challenges.create_btn"
        linkToBtnLink="/create-challenge"
        subtitle={i18next.t("challenges.desc")}
        filterButtons={filterButtons}
        selectedFilter={selectedCreatorType}
        setSelectedFilter={setSelectedCreatorType}
        disableBadges={loading}
        background={
          brand.cover.challenges ? brand.cover.challenges : challs_background
        }
        setChallengeTitle={setChallengeTitle}
        zone={zone}
      />

      <Flex align="center" justify="between">
        <Heading as="h2" size="3">
          {i18next.t(challengeTitle || i18next.t("challenges.headline.new"))}
        </Heading>
        <Flex gap="3">
          {(selectedGame !== undefined || selectedStatus !== "ongoing") && (
            <Button
              onClick={() => {
                setSelectedStatus("ongoing");
                setSelectedGames(undefined);
              }}
            >
              <Cross1Icon />
            </Button>
          )}

          {!brand.event.isEvent && (
            <Flex gap="3" mb="3">
              <SelectDropdownFilter
                setState={setSelectedStatus}
                state={selectedStatus}
                defaultSelected="ongoing"
                optionsList={DropdownStatusOptions}
              />
            </Flex>
          )}
        </Flex>
      </Flex>
    </>
  );
};
